import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { COMPONENTS } from '../../../../routers/constants'
import { PopupActivateResult } from './PopupActivateResult'

const SUCCESS_PARAM = 'TransactionSuccess'
const TIMER_FIRST_POPUP = 5000
const TIMER_SECOND_POPUP = 10000

export const DisplayPopupResult = () => {
  const location = useLocation()

  const [isShow, setIsShow] = useState(true)
  const [isShowSecondPopup, setIsShowSecondPopup] = useState(false)

  const {
    PaymentStatus,
    Subscription,
    SubscriptionStartDate,
    SubscriptionEndDate,
    Package,
    PackageStartDate,
    PackageEndDate,
    UserType,
  } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const isBuyBoth = Subscription && Package

  useEffect(() => {
    if (!isShow) {
      setIsShowSecondPopup(true)
    }
  }, [isShow])

  useEffect(() => {
    setTimeout(() =>
      window.history.pushState(
        '',
        '',
        COMPONENTS.userManagement.components.subscriptionPayment.route,
      ),
    )
  }, [])

  return (
    PaymentStatus === SUCCESS_PARAM &&
    (isBuyBoth ? (
      <>
        <PopupActivateResult
          isBuyPackage={Package}
          startDatePackage={PackageStartDate}
          endDatePackage={PackageEndDate}
          isShow={isShow}
          setIsShow={setIsShow}
          timer={TIMER_FIRST_POPUP}
        />
        <PopupActivateResult
          isBuySubscription={Subscription}
          startDateSubscription={SubscriptionStartDate}
          endDateSubscription={SubscriptionEndDate}
          userType={UserType}
          isShow={isShowSecondPopup}
          setIsShow={setIsShowSecondPopup}
          timer={TIMER_SECOND_POPUP}
        />
      </>
    ) : (
      <PopupActivateResult
        startDatePackage={PackageStartDate}
        endDatePackage={PackageEndDate}
        isBuySubscription={Subscription}
        isBuyPackage={Package}
        startDateSubscription={SubscriptionStartDate}
        endDateSubscription={SubscriptionEndDate}
        userType={UserType}
        isShow={isShow}
        setIsShow={setIsShow}
        timer={TIMER_FIRST_POPUP}
      />
    ))
  )
}
